<template>
    <div class="mb-xl-10">
        <v-row class="justify-center align-center">
            <v-col cols="12" sm="8" md="7" lg="3">
                <span
                    class="
                        text-display-large text-left
                        font-weight-regular
                        text-typography1
                    "
                >
                    Privacy Policy
                </span>
            </v-col>
            <v-col cols="12" sm="8" md="7" lg="5">
                <ul class="text-body-1 text-start">
                    <li>
                        <strong>Last updated June 13, 2023</strong>
                    </li>
                    <li>
                        Thank you for choosing to visit ArupCompute. All
                        visitors and users of the compute.arup.digital website
                        and associated ArupCompute services and integrations are
                        subject to Arup's Staff Privacy Notice, which can be
                        found
                        <a
                            href="https://arup.sharepoint.com/sites/essentials-global-legal/sitepages/Data-Protection--Data-Privacy.aspx#documents-by-region"
                            target="_blank"
                            >here</a
                        >.
                    </li>
                    <li>
                        Arup is committed to protecting the personal data we
                        hold about our staff, clients and others. If you have
                        any questions or concerns about Arup's Staff Privacy
                        Notices, or Arup's practices with regards to your
                        personal information, please contact your regional Data
                        Privacy Champion or the Information & Data Privacy
                        Coordinator at
                        <a href="mailto:privacy@arup.com">privacy@arup.com</a>.
                    </li>
                </ul>
            </v-col>
        </v-row>
    </div>
</template>

<style scoped>
li {
    list-style-position: outside;
    list-style-type: none;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
}

ul {
    padding: 0;
}
</style>
